<div [class.isPrinting]="printService.isPrinting">


  <div class="row">
    <div class="col-md-12 padding-right-0px padding-left-0px margin-top-10">
      <div class="card">
        <div class="card-header wh-header font-size-16px font-weight-normal border-bottom1px-solidgray border-left15px-solidgray padding-top-6px padding-left-15px">
          <div class="row">
            <div class="col-md-10">
              <label class="margin-bottom-0px color-backarrow font-size-25px font-weight-bold">Services list</label>
            </div>
            <div class="col-md-1 padding-left-0px">
              <a class="nav-link-hand education-navlink data-color-new" title="print" (click)="printservices()">
                <span class="badge font-size-16px padding-left-0px padding-top-0px padding-bottom-0px"><i class="fa fa-print"></i></span>
              </a>
            </div>

          </div>
        </div>
        <div class="card-body">
          <!--<div class="row">
    <div class="form-group col-md-12 col-xs-12 margin-bottom-5px">
      <div class="row">
        <div class="col-md-1 text-align-right padding-left-0px">
          <label for="firstName" class="margin-bottom-0px margin-top-5px">Bill No</label>
        </div>:
        <div class="col-md-3">
          <select class="form-control" (change)="onChange($event.target.value)">
            <option selected="selected" value=""></option>
            <option *ngFor="let l of BillCodes">
              {{l.BillCode}}
            </option>
          </select>

        </div>

      </div>

    </div>
  </div>-->
          <!--<div class="row" *ngIf="ItemsData">
    <div class="col-md-12">
      <div class="table-component">
        <div class="table-responsive overflow-x">


          <table class="table table-striped"
                 cols="auto,2*,*,*,*,*,*,*">

            <thead class="">
              <tr>

                <th class="min-width-24px padding-bottom-4px padding-top-4px">
                  #
                </th>
                <th class="padding-top-4px padding-bottom-4px">
                  Date
                </th>

                <th class="padding-top-4px padding-bottom-4px">
                  Service Description
                </th>
                <th class=" padding-top-4px padding-bottom-4px padding-right-0px">
                  Item Rate
                </th>
                <th class="text-align-center padding-right-0px padding-top-4px padding-bottom-4px">
                  QTY
                </th>



                <th class=" padding-right-0px padding-top-4px padding-bottom-4px">
                 Branch
                </th>










              </tr>
            </thead>

            <tbody class="table-body">
              <tr *ngFor="let l of SelectedBillItems;let RowIndex = index">


                <td class="td-padding-tb">

                  {{RowIndex+1}}
                </td>
                <td class=" td-padding-tb">{{l.BillDate | date:'MMM-dd-yyyy'}}</td>

                <td class=" td-padding-tb">{{l.ItemDescription}}</td>
                <td class=" td-padding-tb text-align-center padding-left-0px">{{l.ItemValue}}</td>

                <td class="text-align-center td-padding-tb padding-right-0px">{{l.Quantity}}</td>

                <td class="td-padding-tb padding-right-0px">{{l.BranchName}}</td>



              </tr>

            </tbody>



          </table>
        </div>
      </div>
    </div>
  </div>-->


          <!--<div class="row margin-left-0px margin-top-10" *ngFor="let l of BillCodes">
            <div class="col-md-6">
              <h4 class="margin-bottom-0px color-Assign font-weight-bold">{{l.BillCode}} ({{l.BillDate | date:'MMM-dd-yyyy'}})</h4>

            </div>
            <div class="col-md-5 text-align-right padding-left-0px">
              <h4 class="margin-bottom-0px color-Assign font-weight-bold">[{{l.BranchName}}]</h4>

            </div>
            <div class="col-md-11">

              <div class="row">
                <div class="col-md-12">
                  <div class="table-component margin-bottom-0px">
                    <div class="table-responsive overflow-x">


                      <table class="table table-striped"
                             cols="auto,2*,*,*,*,*,*,*">

                        <thead class="">
                          <tr>

                            <th class="min-width-24px padding-bottom-4px padding-top-4px">
                              #
                            </th>
                            <th class="padding-top-4px padding-bottom-4px padding-left-5px">
                              Service Description
                            </th>
                            <th class=" padding-top-4px padding-bottom-4px padding-right-0px text-align-right">
                              Item Total
                            </th>
                            <th class="text-align-center padding-right-0px padding-top-4px padding-bottom-4px">
                              QTY
                            </th>
                          </tr>
                        </thead>

                        <tbody class="table-body">
                          <tr *ngFor="let d of GetItems(l.BillCode);let RowIndex = index">


                            <td class="td-padding-tb">

                              {{RowIndex+1}}
                            </td>
                            <td class=" td-padding-tb">{{d.ItemDescription}}</td>
                            <td class=" td-padding-tb text-align-right  padding-right-0px">{{d.ItemValue}}</td>

                            <td class="text-align-center td-padding-tb padding-right-0px">{{d.Quantity}}</td>

                          </tr>

                        </tbody>



                      </table>
                    </div>
                  </div>
                </div>
              </div>

              <div class="row margin-top-5px margin-bottom-5px">
                <div class=" offset-md-8 col-md-4">
                  <div class="row font-size-12px">

                    <div class="col-md-6 margin-left-auto text-align-right padding-right-10px">
                      <h4 class="font-weight-normal font-size-12px margin-bottom-0px">Total Value </h4>
                    </div>:
                    <div class="col-md-3 padding-right-0px padding-left-10px">
                      <h4 class="font-weight-normal font-size-12px margin-bottom-0px color-Assign">{{l.NetBillValue}}</h4>
                    </div>
                  </div>
                </div>
              </div>


            </div>
          </div>-->

          <div class="row margin-left-0px">
            <div class="col-md-12">
              <ul class="nav nav-tabs nav-tab-service2" id="tabContent">
                <!--<li class="active margin-right-15px"><a class="nav-itemerp active" href="#allbills" data-toggle="tab">All Bills</a></li>-->
                <li class="active margin-right-15px"><a class="nav-itemerp active" href="#opbills" data-toggle="tab">OP Bills</a></li>
                <li class="margin-right-15px"><a class="nav-itemerp" href="#rxbills" data-toggle="tab">RX Bills</a></li>
              </ul>
              <div class="tab-content">
                <!--<div class="tab-pane active" id="allbills">
                  <div class="row margin-left-0px margin-top-10" *ngFor="let l of AllBills">
                    <div class="col-md-6">
                      <h4 class="margin-bottom-0px color-Assign font-weight-bold">{{l.BillCode}} ({{l.BillDate | date:'MMM-dd-yyyy'}})</h4>

                    </div>
                    <div class="col-md-5 text-align-right padding-left-0px">
                      <h4 class="margin-bottom-0px color-Assign font-weight-bold">[{{l.BranchName}}]</h4>

                    </div>
                    <div class="col-md-11">

                      <div class="row">
                        <div class="col-md-12">
                          <div class="table-component margin-bottom-0px">
                            <div class="table-responsive overflow-x">


                              <table class="table table-striped"
                                     cols="auto,2*,*,*,*,*,*,*">

                                <thead class="">
                                  <tr>

                                    <th class="min-width-24px padding-bottom-4px padding-top-4px">
                                      #
                                    </th>
                                    <th class="padding-top-4px padding-bottom-4px padding-left-5px">
                                      Service Description
                                    </th>
                                    <th class=" padding-top-4px padding-bottom-4px padding-right-0px text-align-right">
                                      Item Total
                                    </th>
                                    <th class="text-align-center padding-right-0px padding-top-4px padding-bottom-4px">
                                      QTY
                                    </th>
                                  </tr>
                                </thead>

                                <tbody class="table-body">
                                  <tr *ngFor="let d of GetItemsAllBills(l.BillCode);let RowIndex = index">
                                    <td class="td-padding-tb">
                                      {{RowIndex+1}}
                                    </td>
                                    <td class=" td-padding-tb">{{d.ItemDescription}}</td>
                                    <td class=" td-padding-tb text-align-right  padding-right-0px">{{d.ItemValue}}</td>
                                    <td class="text-align-center td-padding-tb padding-right-0px">{{d.Quantity}}</td>
                                  </tr>
                                </tbody>
                              </table>
                            </div>
                          </div>
                        </div>
                      </div>

                      <div class="row margin-top-5px margin-bottom-5px">
                        <div class=" offset-md-8 col-md-4">
                          <div class="row font-size-12px">

                            <div class="col-md-6 margin-left-auto text-align-right padding-right-10px">
                              <h4 class="font-weight-normal font-size-12px margin-bottom-0px">Total Value </h4>
                            </div>:
                            <div class="col-md-3 padding-right-0px padding-left-10px">
                              <h4 class="font-weight-normal font-size-12px margin-bottom-0px color-Assign">{{l.NetBillValue}}</h4>
                            </div>
                          </div>
                        </div>
                      </div>

                    </div>
                  </div>
                </div>-->

                <div class="tab-pane active" id="opbills">
                  <div class="row margin-left-0px margin-top-10" *ngFor="let l of BillCodesOP">
                    <div class="col-md-6">
                      <h4 class="margin-bottom-0px color-Assign font-weight-bold">{{l.BillCode}} ({{l.BillDate | date:'MMM-dd-yyyy'}})</h4>

                    </div>
                    <div class="col-md-5 text-align-right padding-left-0px">
                      <h4 class="margin-bottom-0px color-Assign font-weight-bold">[{{l.BranchName}}]</h4>

                    </div>
                    <div class="col-md-11">

                      <div class="row">
                        <div class="col-md-12">
                          <div class="table-component margin-bottom-0px">
                            <div class="table-responsive overflow-x">


                              <table class="table table-striped"
                                     cols="auto,2*,*,*,*,*,*,*">

                                <thead class="">
                                  <tr>

                                    <th class="min-width-24px padding-bottom-4px padding-top-4px">
                                      #
                                    </th>
                                    <th class="padding-top-4px padding-bottom-4px padding-left-5px">
                                      Service Description
                                    </th>
                                    <th class=" padding-top-4px padding-bottom-4px padding-right-0px text-align-right">
                                      Item Total
                                    </th>
                                    <th class="text-align-center padding-right-0px padding-top-4px padding-bottom-4px">
                                      QTY
                                    </th>
                                  </tr>
                                </thead>

                                <tbody class="table-body">
                                  <tr *ngFor="let d of GetItemsOP(l.BillCode);let RowIndex = index">
                                    <td class="td-padding-tb">
                                      {{RowIndex+1}}
                                    </td>
                                    <td class=" td-padding-tb">{{d.ItemDescription}}</td>
                                    <td class=" td-padding-tb text-align-right  padding-right-0px">{{d.ItemValue}}</td>
                                    <td class="text-align-center td-padding-tb padding-right-0px">{{d.Quantity}}</td>
                                  </tr>
                                </tbody>
                              </table>
                            </div>
                          </div>
                        </div>
                      </div>

                      <div class="row margin-top-5px margin-bottom-5px">
                        <div class=" offset-md-8 col-md-4">
                          <div class="row font-size-12px">

                            <div class="col-md-6 margin-left-auto text-align-right padding-right-10px">
                              <h4 class="font-weight-normal font-size-12px margin-bottom-0px">Total Value </h4>
                            </div>:
                            <div class="col-md-3 padding-right-0px padding-left-10px">
                              <h4 class="font-weight-normal font-size-12px margin-bottom-0px color-Assign">{{l.NetBillValue}}</h4>
                            </div>
                          </div>
                        </div>
                      </div>

                    </div>
                  </div>
                </div>

                <div class="tab-pane" id="rxbills">
                  <div class="row margin-left-0px margin-top-10" *ngFor="let l of BillCodesRX">
                    <div class="col-md-6">
                      <h4 class="margin-bottom-0px color-Assign font-weight-bold">{{l.BillCode}} ({{l.BillDate | date:'MMM-dd-yyyy'}})</h4>

                    </div>
                    <div class="col-md-5 text-align-right padding-left-0px">
                      <h4 class="margin-bottom-0px color-Assign font-weight-bold">[{{l.BranchName}}]</h4>

                    </div>
                    <div class="col-md-11">
                      <div class="row">
                        <div class="col-md-12">
                          <div class="table-component margin-bottom-0px">
                            <div class="table-responsive overflow-x">


                              <table class="table table-striped"
                                     cols="auto,2*,*,*,*,*,*,*">

                                <thead class="">
                                  <tr>

                                    <th class="min-width-24px padding-bottom-4px padding-top-4px">
                                      #
                                    </th>
                                    <th class="padding-top-4px padding-bottom-4px padding-left-5px">
                                      Service Description
                                    </th>
                                    <th class=" padding-top-4px padding-bottom-4px padding-right-0px text-align-right">
                                      Item Total
                                    </th>
                                    <th class="text-align-center padding-right-0px padding-top-4px padding-bottom-4px">
                                      QTY
                                    </th>
                                  </tr>
                                </thead>

                                <tbody class="table-body">
                                  <tr *ngFor="let d of GetItemsRX(l.BillCode);let RowIndex = index">
                                    <td class="td-padding-tb">
                                      {{RowIndex+1}}
                                    </td>
                                    <td class=" td-padding-tb">{{d.ItemDescription}}</td>
                                    <td class=" td-padding-tb text-align-right  padding-right-0px">{{d.ItemValue}}</td>
                                    <td class="text-align-center td-padding-tb padding-right-0px">{{d.Quantity}}</td>
                                  </tr>
                                </tbody>
                              </table>
                            </div>
                          </div>
                        </div>
                      </div>

                      <div class="row margin-top-5px margin-bottom-5px">
                        <div class=" offset-md-8 col-md-4">
                          <div class="row font-size-12px">

                            <div class="col-md-6 margin-left-auto text-align-right padding-right-10px">
                              <h4 class="font-weight-normal font-size-12px margin-bottom-0px">Total Value </h4>
                            </div>:
                            <div class="col-md-3 padding-right-0px padding-left-10px">
                              <h4 class="font-weight-normal font-size-12px margin-bottom-0px color-Assign">{{l.NetBillValue}}</h4>
                            </div>
                          </div>
                        </div>
                      </div>

                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

        </div>
      </div>
    </div>

  </div>

  <div class="row">
    <div class="col-md-12 padding-right-0px padding-left-0px">
      <div class="card">
        <div class="card-header wh-header font-size-16px font-weight-normal border-bottom1px-solidgray border-left15px-solidgray padding-top-6px padding-left-15px">
          <div class="row">
            <div class="col-md-10">
              <label class="margin-bottom-0px">Refund list</label>
            </div>
            

          </div>
        </div>
        <div class="card-body padding-all-0px">
          <!--<div class="row">
            <div class="form-group col-md-12 col-xs-12 margin-bottom-5px">
              <div class="row">
                <div class="col-md-1 text-align-right padding-left-0px">
                  <label for="firstName" class="margin-bottom-0px margin-top-5px">Bill No</label>
                </div>:
                <div class="col-md-3">
                  <select class="form-control" (change)="onChange($event.target.value)">
                    <option selected="selected" value=""></option>
                    <option *ngFor="let l of BillCodes">
                      {{l.BillCode}}
                    </option>
                  </select>

                </div>

              </div>

            </div>
          </div>-->
          <!--<div class="row" *ngIf="ItemsData">
            <div class="col-md-12">
              <div class="table-component">
                <div class="table-responsive overflow-x">


                  <table class="table table-striped"
                         cols="auto,2*,*,*,*,*,*,*">

                    <thead class="">
                      <tr>

                        <th class="min-width-24px padding-bottom-4px padding-top-4px">
                          #
                        </th>
                        <th class="padding-top-4px padding-bottom-4px">
                          Date
                        </th>

                        <th class="padding-top-4px padding-bottom-4px">
                          Service Description
                        </th>
                        <th class=" padding-top-4px padding-bottom-4px padding-right-0px">
                          Item Rate
                        </th>
                        <th class="text-align-center padding-right-0px padding-top-4px padding-bottom-4px">
                          QTY
                        </th>



                        <th class=" padding-right-0px padding-top-4px padding-bottom-4px">
                         Branch
                        </th>










                      </tr>
                    </thead>

                    <tbody class="table-body">
                      <tr *ngFor="let l of SelectedBillItems;let RowIndex = index">


                        <td class="td-padding-tb">

                          {{RowIndex+1}}
                        </td>
                        <td class=" td-padding-tb">{{l.BillDate | date:'MMM-dd-yyyy'}}</td>

                        <td class=" td-padding-tb">{{l.ItemDescription}}</td>
                        <td class=" td-padding-tb text-align-center padding-left-0px">{{l.ItemValue}}</td>

                        <td class="text-align-center td-padding-tb padding-right-0px">{{l.Quantity}}</td>

                        <td class="td-padding-tb padding-right-0px">{{l.BranchName}}</td>



                      </tr>

                    </tbody>



                  </table>
                </div>
              </div>
            </div>
          </div>-->
         
          
         

              <div class="row">
                <div class="col-md-12">
                  <div class="table-component margin-bottom-0px">
                    <div class="table-responsive overflow-x">


                      <table class="table table-striped"
                             cols="auto,2*,*,*,*,*,*,*">

                        <thead class="">
                          <tr>

                            <th class="min-width-24px padding-bottom-4px padding-top-4px">
                              #
                            </th>
                            <th class="padding-top-4px padding-bottom-4px">
                              Date
                            </th>
                            <!--<th class="padding-top-4px padding-bottom-4px">
                              Branch
                            </th>-->
                            <th class="padding-top-4px padding-bottom-4px padding-left-5px">
                              Service Description
                            </th>
                            <th class=" padding-top-4px padding-bottom-4px padding-right-0px text-align-right">
                              ItemTotal
                            </th>
                            <th class="text-align-right  padding-top-4px padding-bottom-4px">
                              Refund Total
                            </th>



                            <!--<th class=" padding-right-0px padding-top-4px padding-bottom-4px">
    Branch
  </th>-->










                          </tr>
                        </thead>

                        <tbody class="table-body">
                          <tr *ngFor="let d of RefundData;let RowIndex = index">


                            <td class="td-padding-tb">

                              {{RowIndex+1}}
                            </td>
                            <td class=" td-padding-tb">{{d.RefundPaidDate | date:'MMM-dd-yyyy'}}</td>
                            <!--<td class=" td-padding-tb">{{d.ItemDescription}}</td>-->
                            <td class=" td-padding-tb">{{d.ItemDescription}}</td>
                            <td class=" td-padding-tb text-align-right  padding-right-0px">{{d.ItemTotal| number:'1.0-0' |removeComma}}</td>

                            <td class="text-align-right td-padding-tb">{{d.RefundTotal| number:'1.0-0' |removeComma}}</td>

                            <!--<td class="td-padding-tb padding-right-0px">{{d.BranchName}}</td>-->



                          </tr>

                        </tbody>



                      </table>
                    </div>
                  </div>
                </div>
              </div>

              <!--<div class="offset-md-6 col-md-6">

                <h4>Total Value</h4>: <h4 class="font-weight-bold color-Assign">{{l.NetBillValue}}</h4>
              </div>-->
              


           
         

        </div>
      </div>
    </div>

  </div>




  <router-outlet></router-outlet>
  <router-outlet name="print"></router-outlet>
</div>

<!--<div class="row" *ngIf="Formedit">
  <div class="col-md-8 padding-left-0px">


    <div class="card">

      <div class="card-body padding-all-0px">
        <div *ngIf="FormData" class="margin-top-10">


          <div class="row card margin-left-0px margin-right-0px margin-bottom-5px" *ngFor="let l of FormData;let RowIndex = index">

            <div [id]="'accordion'+RowIndex">
              <div class="card-header wh-header font-size-16px  padding-top-6px padding-bottom-6px card-header-bg border-left-clinical padding-l-8px padding-right-8px font-weight-normal2 font-size-16px" [id]="'heading'+RowIndex">
                <div class="row">
                  <div class="col-md-3">
                    <h5 class="mb-0">
                      <button class="btn btn-link btn-cycles padding-top-0px padding-bottom-0px padding-right-0px padding-left-0px" type="button" data-toggle="collapse" [attr.data-target]="'#collapse_cre'+RowIndex"
                              aria-expanded="true" [attr.aria-controls]="'collapse_cre'+RowIndex">
                        {{l.Title}}

                      </button>

                    </h5>
                  </div>
                  <div class="col-md-9">
                    <button type="submit" class="btn actions-btn-prime float-right">Save</button>
                    <button type="button"
                            (click)="Backtolist()" class="btn actions-btn-prime nav-link-hand button-Schedule actions-btn-prime3 float-right margin-right-10px">
                      Cancel
                    </button>
                  </div>
                </div>


              </div>
              <div [id]="'collapse_cre'+RowIndex" class="collapse show collapse-show3" [attr.aria-labelledby]="'heading'+RowIndex"
                   [attr.data-parent]="'#accordion'+RowIndex">
                <div class="card-body padding-bottom-19px padding-right-0px padding-top-0px">

                  <div class="row col-md-12 card" *ngFor="let f of l.Fields">


                    <div class="card-header wh-header font-size-14 padding-l-8px padding-t-6px padding-bottom-0px padding-right-0px" *ngIf="f.isHeader">
                      {{f.Title}}
                    </div>
                    <div class="card-body padding-bottom-0px padding-top-0px margin-left-zero">
                      <div *ngIf="f.isSubHeader">
                        <label class="font-size-14 margin-bottom-0px">{{f.Title}}</label>
                      </div>


                      <div *ngIf="f.isTextField">
                        <div class="row form-group">
                          <div class="col-md-3 padding-right-0px text-align-right">
                            <label class="font-size-12px margin-bottom-0px margin-top-10">{{f.Title}}</label>
                          </div>
                          <div class="col-md-3">
                            <input type="text" class="form-control" placeholder="Value" required maxlength="100" minlength="1">
                          </div>
                        </div>


                      </div>
                      <div *ngIf="f.isSubChild">
                        <div class="row form-group">
                          <div class="col-md-3 text-align-right">
                            <label class="font-size-12px margin-bottom-0px margin-top-10">{{f.Title}}</label>
                          </div>:
                          <div class="col-md-3">
                            <input type="text" class="form-control" placeholder="Value" required maxlength="100" minlength="1">
                          </div>
                        </div>
                      </div>


                      <div *ngIf="f.Remarks">
                        <label class="margin-left-10px margin-bottom-0px">{{f.Remarks}}</label>
                      </div>
                      <div *ngIf="f.HasSeparator">
                        <div class="border-bottom-light"></div>
                      </div>
                    </div>
                  </div>



                </div>
              </div>
            </div>

          </div>

        </div>
      </div>
    </div>
  </div>
  <div class="col-md-4">

  </div>
</div>-->
<!--<div class="row">
  <div class="col-md-12">
    <medicalrecordview [FormattedCode]="FormattedCode" *ngIf="viewhealthrecord"></medicalrecordview>
  </div>

</div>-->
